
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/flamingo",
      function () {
        return require("private-next-pages/products/flamingo/index.tsx");
      }
    ]);
  